export default __webpack_public_path__ + "static/media/Ferramentas.d3b032a6.png";